var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _circle3, _circle4, _path3, _circle5, _circle6, _path4, _path5, _circle7, _circle8, _circle9, _circle10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerTimeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 258,
    viewBox: "0 0 295 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 129,
    r: 92,
    fill: "#F3F7FD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 129,
    r: 72,
    fill: "#FFFFFF",
    stroke: "#407EC9",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136.5,
    y: 49,
    width: 22,
    height: 12,
    rx: 6,
    fill: "#407EC9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 57,
    width: 34,
    height: 12,
    rx: 6,
    fill: "#407EC9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 65,
    width: 1,
    height: 12,
    fill: "#407EC9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 181,
    width: 1,
    height: 12,
    fill: "#407EC9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 129,
    width: 12,
    height: 1,
    fill: "#407EC9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 129,
    width: 12,
    height: 1,
    fill: "#407EC9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 184.143,
    y: 76.357,
    width: 1,
    height: 8,
    transform: "rotate(45 184.143 76.357)",
    fill: "#C2D5EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 111.357,
    y: 76.357,
    width: 1,
    height: 8,
    transform: "rotate(-45 111.357 76.357)",
    fill: "#C2D5EE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 184.143,
    y: 181.643,
    width: 1,
    height: 8,
    transform: "rotate(135 184.143 181.643)",
    fill: "#C2D5EE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111.357,
    y: 181.643,
    width: 1,
    height: 8,
    transform: "rotate(-135 111.357 181.643)",
    fill: "#C2D5EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 129L147.5 87",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 129L186 148",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.5,
    cy: 129,
    r: 6,
    fill: "#407EC9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 83,
    r: 18,
    fill: "#FEF2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5 71V89",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.5,
    cy: 95,
    r: 2,
    fill: "#EF4444"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 83,
    r: 18,
    fill: "#FEF2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 76L94.5 90",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 76L80.5 90",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 200,
    r: 12,
    fill: "#C2D5EE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 180,
    r: 8,
    fill: "#C2D5EE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 60,
    r: 15,
    fill: "#F3F7FD"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 50,
    r: 10,
    fill: "#F3F7FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerTimeout);
export default __webpack_public_path__ + "static/media/timer_timeout.95fa4a2b6b170470b64d70543caeeba4.svg";
export { ForwardRef as ReactComponent };